import { render, staticRenderFns } from "./VstRegAdviser.vue?vue&type=template&id=722d7ca2&"
import script from "./VstRegAdviser.vue?vue&type=script&lang=js&"
export * from "./VstRegAdviser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports